module.exports = __webpack_public_path__ + "static/pid-ug-1-en-home-9fcacb65c058baf1efc115bbd5da7c5c.png";